import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import PolicyTableStore from '../../stores/Policy/PolicyTableStore';
import SnackStore from '../../stores/SnackStore';
import FuseConfirmationModal from '../ConfirmationModal/FuseConfirmationModal';
import FuseConsoleModal from '../ConsoleModal/FuseConsoleModal';
import FuseButton from '../FuseControls/FuseButton';

class PriorityModal extends Component {
    static propTypes = {
        snack: SnackStore.PropType.isRequired,
        store: PolicyTableStore.PropType.isRequired,
        errMsg: PropTypes.string,
        subTitle: PropTypes.string,
    };

    onSave = () => {
        const { store, errMsg, snack, subTitle } = this.props;

        store.changePriorities()
            .then(store.priorityChangeModal.close)
            .then(() => snack.showSuccess(
                `The priority has been updated ${subTitle ? ('for ' + subTitle.replace('-', '').trim() + '.') : ''}`)
            )
            .catch((error) => snack.showError(`${errMsg} ${error.message}`));
    };

    render() {
        const { store, subTitle, children } = this.props;

        return <Fragment>
            <FuseConsoleModal
                isOpen={store.priorityChangeModal.value}
                onClose={() => {
                    if (store.hasOrderChanged()) {
                        store.cancelPriorityChangeConfirmationModal.show();
                    } else {
                        store.priorityChangeModal.close();
                    }
                }}
                title={'Change Priority'}
                subTitle={subTitle}
                headerActions={[
                    <FuseButton
                        style={{ minWidth: 100 }}
                        key={0}
                        color={'green'}
                        primary
                        disabled={!store.hasOrderChanged()}
                        loading={store.priorityChangeStatus.isLoading}
                        qa="priority-save"
                        onClick={this.onSave}
                    >Save</FuseButton>,
                ]}
            >
                {children}
            </FuseConsoleModal>
            <FuseConfirmationModal
                store={store.cancelPriorityChangeConfirmationModal}
                onConfirm={store.priorityChangeModal.close}
            />
        </Fragment>;
    }
}

export default inject('snack')(observer(PriorityModal));
